module.exports = __webpack_public_path__ + "lf-im-scaglie.jpg?4b84df05b76a7878b56a3190d8bcbf8e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lf-im-scaglie.jpg
// module id = 222
// module chunks = 0